<div *ngIf="pollData" [class.smallPollContainer]="small" class="pollContainer">
    <div class="d-flex gap-10 align-items-start">
        <div>
            <h3 class="my-0">{{ pollData.text }}</h3>
            <div class="italic">{{ pollData.description }}</div>
        </div>
    </div>
    <ng-container *ngIf="pollData.scale && !showResult">
        <ng-container *ngFor="let question of pollData.questions; let index = i">
            <ng-container [ngTemplateOutletContext]="{question:question}"
                          [ngTemplateOutlet]="questionContent"></ng-container>
        </ng-container>

        <div *ngIf="!hasTimePassed && !preview && (hasCommunityRole(['member']) || this.hasCommunityRole(['full_admin']))"
             class="mt-20 d-flex flex-space-between align-items-end gap-5">
            <div><span *ngIf="pollData.end_at"
                       class="textAccent">* The poll will close {{ pollData.end_at | relativeTime }}</span>
            </div>
            <button (click)="vote()" *ngIf="!showResult" [disabled]="!pollVoteValid || voteSending"
                    color="accent" mat-raised-button>
                Vote
                <mat-icon *ngIf="voteSending">
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            </button>
            <!--            <button *ngIf="showResult" mat-raised-button color="accent" (click)="changeVote()">Change vote-->
            <!--            </button>-->
        </div>
    </ng-container>


    <ng-container *ngIf="!pollData.scale || showResult">


        <div [class.mt-10]="small" [class.mt-20]="!small">

            <mat-stepper #stepper (stepsChanged)="updateSteps($event)"
                         [class.hideheader]="pollData.questions?.length <=1 "
                         [linear]="true" appStepperWatcher
                         class="pollStepper">
                <ng-container>
                    <ng-container *ngFor="let question of pollData.questions; let index = i">
                        <!--                        [label]="question.text"-->
                        <mat-step *ngIf="displayConditionsMet(question)">
                            <ng-container [ngTemplateOutletContext]="{question:question}"
                                          [ngTemplateOutlet]="questionContent"></ng-container>
                        </mat-step>
                    </ng-container>
                </ng-container>
            </mat-stepper>


        </div>
        <div *ngIf="!hasTimePassed && !preview && (hasCommunityRole(['member']) || this.hasCommunityRole(['full_admin']))"
             class="mt-20 d-flex flex-space-between align-items-end gap-5">
            <div><span *ngIf="pollData.end_at"
                       class="textAccent">* The poll will be closed {{ pollData.end_at | relativeTime }}</span>
            </div>
            <button (click)="stepper.next()" *ngIf="!showResult && steps > 1 && steps !== stepper.selectedIndex + 1"
                    [disabled]="!questionPollVoteValid(getQuestion(stepper.selectedIndex))"
                    color="accent" mat-raised-button>
                Next question
            </button>
            <button (click)="vote()" *ngIf="!showResult && steps === stepper.selectedIndex + 1"
                    [disabled]="steps !== pollData.questions?.length ? !questionPollVoteValid(getQuestion(stepper.selectedIndex)) : !pollVoteValid"
                    color="accent"
                    mat-raised-button>
                Vote
            </button>
            <!--            <button *ngIf="showResult" mat-raised-button color="accent" (click)="changeVote()">Change vote-->
            <!--            </button>-->
        </div>
    </ng-container>

</div>

<ng-template #questionContent let-question="question">
    <h3>{{ question.text }}</h3>
    <h5 *ngIf="question.description">{{ question.description }}</h5>
    <div [class.flex-row]="pollData.scale && !showResult"
         [class.flex-space-around]="pollData.scale && !showResult" [class.gap-10]="pollData.scale">
        <div *ngFor="let option of question.options" [class.flex-even]="pollData.scale" [class.mb-10]="small"
             [class.mb-15]="!small"
             [ngStyle]="{ width: pollData.scale && !showResult ? 'calc(100%/' + question.options.length + ')' : '' }"
             class="flex-col gap-5" data-test="calc(100%/' + question.options.length + ');'">
            <ng-container
                    [ngTemplateOutletContext]="{option, question}"
                    [ngTemplateOutlet]="question.multiple_choices ? multipleChoice : singleChoice"></ng-container>
        </div>
        <small *ngIf="question.max_responses && question?.results?.length >= question.max_responses && !preview && !showResult">
            You can only select {{ question.max_responses }} options. Unselect an option to select another.
        </small>

    </div>
</ng-template>
<ng-template #multipleChoice let-option="option" let-question="question">
    <div class="flex-row gap-10">
        <div class="voteBlock">
            <div *ngIf="showResult" class="percentage">{{ getPercentage(option.votes_count) }}
                <br>({{ option.votes_count }} Votes)
            </div>

            <mat-checkbox #opt (change)="setResult(question, 'results', option,true)"
                          [checked]="question.results?.includes(option.id)" [disableRipple]="true"
                          [disabled]="preview || ((question.max_responses && question?.results?.length >= question.max_responses) && !question.results?.includes(option.id))"
                          [hidden]="showResult"
                          [value]="option.id"
                          color="accent">
            </mat-checkbox>

        </div>
        <div (click)="!showResult && opt._onInputClick()" [class.cursorPointer]="!showResult"
             [class.mt-5]="small" [class.showResult]="showResult"
             class="flex-col w-100 option-detail justify-content-center">
            <ng-container [ngTemplateOutletContext]="{
                              count:option.votes_count,
                              text: option.text,
                              description:option.description,
                              checked: question.results?.includes(option.id),
                              showResult,
                              userVoted: pollData.user_vote.includes(option.id)
                          }"
                          [ngTemplateOutlet]="resultBar"></ng-container>
        </div>
    </div>
    <ng-container *ngIf="(question.results?.includes(option.id)|| showResult) && option.nested_options.length > 0"
                  [ngTemplateOutletContext]="{option}"
                  [ngTemplateOutlet]="nestedOptions">
    </ng-container>
</ng-template>

<ng-template #singleChoice let-option="option" let-question="question">
    <div [ngClass]="pollData.scale && !showResult? 'flex-reverse-col': 'flex-row gap-10'">
        <div class="voteBlock">
            <mat-radio-button #opt (change)="setResult(question, 'results',option,false)"
                              [checked]="question.results?.includes(option.id)"
                              [disableRipple]="true"
                              [disabled]="preview"
                              [hidden]="showResult"
                              [name]="'nestedPollOption-' + question.id" [value]="option.id"
                              color="accent">
            </mat-radio-button>

        </div>
        <div (click)="!showResult && opt._inputElement.nativeElement.click()" [class.cursorPointer]="!showResult"
             [class.flex-col]="pollData.scale" [class.mt-5]="small"
             [class.showResult]="showResult" [class.text-center]="pollData.scale && !showResult"
             class="flex-col w-100 option-detail justify-content-center">
            <ng-container [ngTemplateOutletContext]="{
                              count:option.votes_count,
                              text: option.text,
                              description:option.description,
                              checked: question.results?.includes(option.id),
                              showResult,
                              userVoted: pollData.user_vote.includes(option.id)
                          }"
                          [ngTemplateOutlet]="resultBar"></ng-container>
        </div>
    </div>
    <ng-container *ngIf="(question.results?.includes(option.id)|| showResult) &&  option.nested_options.length> 0"
                  [ngTemplateOutletContext]="{option}"
                  [ngTemplateOutlet]="nestedOptions">
    </ng-container>
</ng-template>

<ng-template #resultBar let-checked="checked" let-count="count" let-description="description"
             let-showResult="showResult"
             let-text="text" let-userVoted="userVoted">
    <div [class.checked]="checked" [class.showResult]="showResult" [class.userVoted]="userVoted" class="bar-container">
        <div [@barWidthAnimation]="{value: '*', params: {width: showResult ? getPercentage(count|| 0) : '0%'}}"
             class="bar"></div>
        <div class="vote-details">
            <div [appTruncatedTooltip]="text">{{ text }}</div>
            <div *ngIf="description" [appTruncatedTooltip]="description" class="italic description">{{ description }}
            </div>
        </div>
        <div *ngIf="showResult" class="percentage">{{ getPercentage(count) }}
            (<span [countUp]="count" [duration]="500"> {{ count }} </span>&nbsp;votes)
        </div>
    </div>
</ng-template>

<ng-template #nestedOptions let-option="option">
    <div class="ml-20 my-10 gap-5 flex-col">
        <h4 class="m-0">{{ option.nested_question_title }}</h4>
        <ng-container *ngFor="let nestedOption of option.nested_options ">
            <app-nested-option
                #optionComponent
                (setResult)="setResult(option, 'nestedResults', nestedOption,$event)"
                [nestedOption]="nestedOption"
                [option]="option"
                [preview]="preview"
                [showResult]="showResult"
            >
                <div (click)="!showResult && optionComponent.click()" [class.cursorPointer]="!showResult"
                     [class.mt-5]="small" [class.showResult]="showResult"
                     class="flex-col w-100 option-detail justify-content-center">
                    <ng-container [ngTemplateOutletContext]="{
                                      count:nestedOption.votes_count,
                                      text: nestedOption.text,
                                      description:nestedOption.description,
                                      checked: option?.nestedResults?.includes(nestedOption.id),
                                      showResult,
                                      userVoted: pollData.user_vote.includes(nestedOption.id)
                                  }"
                                  [ngTemplateOutlet]="resultBar"></ng-container>
                </div>
            </app-nested-option>
        </ng-container>
        <small *ngIf="option.max_nested_responses && option.nested_multiple_choices && option?.nestedResults?.length >= option.max_nested_responses && !preview && !showResult">
            You can only select {{ option.max_nested_responses }} options. Unselect an option to select another.
        </small>
    </div>
</ng-template>

